import { z } from 'zod';
// ---------------------------------------------------------------------------
// Patient to-do tasks (Domain 4 - Cockpit, REQ-VIS-008/051/052)
// ---------------------------------------------------------------------------
/**
 * One to-do task ("problem") of a patient in a trial, legacy `Task`,
 * REQ-VIS-051.
 *
 * The task hangs on the DOMAIN 3 enrollment (`enrollmentId`, legacy
 * `Trial_patient_id`) - never on a visit and never on the patient chart. This
 * is a DIFFERENT object from `patient_additional_tasks` (REQ-VIS-041): the
 * mock-up labels both "zadania", but one is a to-do, the other an execution of
 * an additional procedure.
 *
 * `stopDate`/`stopPersonnelId` are a PAIR enforced by the DB CHECK
 * `patient_tasks_stop_pair`: both `null` while the task is open (REQ-VIS-008),
 * both set when it is closed (REQ-VIS-051).
 */
export const PatientTaskDtoSchema = z.object({
    id: z.number().int().positive(),
    tenantId: z.number().int().positive(),
    enrollmentId: z.number().int().positive(),
    /** "Opis problemu" - required (REQ-VIS-051). */
    name: z.string().min(1).max(255),
    comments: z.string().nullable(),
    startDate: z.iso.date(),
    /** The person who created the task (legacy `Start_personel_id`). */
    startPersonnelId: z.number().int().positive(),
    /** Closing day; `null` means the task is still OPEN (REQ-VIS-008). */
    stopDate: z.iso.date().nullable(),
    stopPersonnelId: z.number().int().positive().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
/**
 * Body of `POST /api/v1/visits/patient-tasks` (REQ-VIS-051).
 *
 * `name` is the required description - a task without one is not storable.
 * `startDate` is the SERVER's today, so the client never dictates it (same
 * stance as the derived procedure date, REQ-VIS-044). The creator
 * (`startPersonnelId`) travels in the BODY: the session identity carries no
 * `personnel_details` link (ADR-006 - application identity is not the medical
 * role), so the dialog asks for the person explicitly.
 */
export const CreatePatientTaskRequestSchema = z.object({
    enrollmentId: z.coerce.number().int().positive(),
    name: z.string().trim().min(1).max(255),
    comments: z.string().max(2000).nullable().optional(),
    startPersonnelId: z.coerce.number().int().positive(),
});
/** Query of `GET /api/v1/visits/patient-tasks` - the OPEN tasks of one enrollment (REQ-VIS-008). */
export const PatientTasksQuerySchema = z.object({
    enrollmentId: z.coerce.number().int().positive(),
});
/**
 * Body of `PATCH /api/v1/visits/patient-tasks/:id/close` (REQ-VIS-051). The
 * closing DAY is the server's today; only the person travels in the body -
 * same reason as the creator above.
 */
export const ClosePatientTaskRequestSchema = z.object({
    stopPersonnelId: z.coerce.number().int().positive(),
});
//# sourceMappingURL=patient-tasks.schema.js.map